import React from 'react';
import { GenericIconProps } from './utils';
import theme from '../utils/theme/theme';

export default function IconSlash(props: GenericIconProps) {
  const { width = 16, height = 16, stroke = theme.colors.black } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 16 16" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-109.000000, -330.000000)"
          stroke={stroke}
          strokeWidth="2"
        >
          <g transform="translate(105.000000, 326.000000)">
            <circle cx="12" cy="12" r="6.66666667" />
            <path d="M7.28666667,7.28666667 L16.7133333,16.7133333" />
          </g>
        </g>
      </g>
    </svg>
  );
}
